import { SET_SIDEBAR_EFFECTIVE_EXPANDED, SET_SIDEBAR_EXPANDED } from './sidebarTypes';

export const setSidebarExpanded = (isExpanded) => ({
  type: SET_SIDEBAR_EXPANDED,
  payload: isExpanded,
});

export const setSidebarEffectiveExpanded = (isEffectiveExpanded) => ({
  type: SET_SIDEBAR_EFFECTIVE_EXPANDED,
  payload: isEffectiveExpanded,
});
